import { useTranslation } from 'next-i18next'

import { SectionEditButton } from 'components/buttons'

import { formatEmploymentHistoryDate } from 'utils/formaters.util'
import orderExperience from 'utils/orderExperience'

import ExpandableIndustries from './ExpandableIndustries'
import ExpandableSkills from './ExpandableSkills'
import { ICVEmploymentHistoryProps } from './types'

const CVEmploymentHistory = ({
  employmentHistory,
  industries,
  editable,
  onEdit
}: ICVEmploymentHistoryProps) => {
  const { t } = useTranslation(['cv_modal', 'cv_form'])
  return (
    <div className="py-5">
      <div className="flex items-center justify-between">
        <h2 className="pb-6 text-2xl font-bold tracking-wide">
          {t('fields.workExperience', { ns: 'cv_modal' })}
          <i className="dot"></i>
        </h2>
        {editable && (
          <SectionEditButton
            data-cy="work-experience-add-modal"
            variant="add"
            onClick={() => onEdit?.(-1)}
          />
        )}
      </div>
      {orderExperience(employmentHistory)?.map((emp, index: number) => (
        <div key={emp.jobTitle + emp.id} className="relative flex items-start">
          <div className="mr-5 flex h-full flex-col flex-wrap items-center justify-between md:hidden">
            <div className="mt-2 h-[6px] w-[6px] overflow-hidden rounded-full bg-black"></div>
            {employmentHistory?.length != index + 1 && (
              <div className="mr-[0.75px] flex-1 before:absolute before:bottom-0 before:h-[calc(100%_-_18px)] before:w-[1px] before:bg-gray-200"></div>
            )}
          </div>
          <div className="relative flex w-full flex-col items-start md:flex-row">
            <div className="flex-[2] text-base font-bold tracking-wider md:text-sm">
              {formatEmploymentHistoryDate(emp.startDate, emp?.endDate, t)}
            </div>
            <div className="mx-5 hidden h-full flex-col items-center justify-between md:flex">
              <div className="mt-2 h-[6px] w-[6px] overflow-hidden rounded-full bg-black"></div>
              {employmentHistory?.length != index + 1 && (
                <div className="mr-[0.75px] flex-1 before:absolute before:bottom-0 before:h-[calc(100%_-_18px)] before:w-[1px] before:bg-gray-200"></div>
              )}
            </div>
            <div className="flex-[8] text-lg md:text-base">
              <div className="flex flex-wrap items-center gap-x-2 font-semibold">
                <span>{emp.jobTitle}</span>
                <span className="font-normal">{emp.employerName}</span>
                <span>
                  {editable && (
                    <SectionEditButton
                      data-cy="work-experience-edit-modal"
                      isPlain
                      onClick={() => onEdit?.(index)}
                    />
                  )}
                </span>
              </div>
              <ExpandableSkills
                skills={emp.skills.map((x) => ({
                  value: x.skillObj?.value ?? x.skill ?? '',
                  years: null
                }))}
              />
            </div>
          </div>
        </div>
      ))}

      {editable && (
        <div className="mb-2">
          <div className="flex items-center justify-between">
            <h2 className="pb-6 text-2xl font-bold tracking-wide">
              {t('fields.industries', { ns: 'cv_modal' })}
              <i className="dot"></i>
            </h2>

            <SectionEditButton
              data-cy="work-experience-add-modal"
              onClick={() => onEdit?.(null)}
            />
          </div>

          <ExpandableIndustries industries={industries} />
        </div>
      )}
    </div>
  )
}

export default CVEmploymentHistory
